import { dataTypeParametersA } from './model-type-params-a';
import { dataTypeParametersB } from './model-type-params-b';
import { ModelTypeConfig } from './model-type-params.types';

export { ModelTypeParam, ModelTypeConfig } from './model-type-params.types';

export const dataTypeParameters: Record<string, ModelTypeConfig> = {
  ...dataTypeParametersA,
  ...dataTypeParametersB,
};

export const getConfigBySubTypeName = (subTypeName: string): ModelTypeConfig | undefined =>
  Object.values(dataTypeParameters).find((config) => config.subTypeName === subTypeName);
